/**
 * Geração automática de texto ALT para imagens de imóveis.
 */

import { getPropertyTypeLabel } from '../../constants/propertyTypes';

function formatPurpose(purpose) {
  if (purpose === 'rent') return 'para alugar';
  if (purpose === 'sale') return 'à venda';
  return '';
}

function countRooms(property) {
  const bedrooms = property.bedrooms || property.seo?.schemaNumberOfRooms;
  if (bedrooms) return `${bedrooms} quarto${bedrooms > 1 ? 's' : ''}`;
  return '';
}

/**
 * Gera ALT descritivo para imagem de imóvel.
 * Exemplo: "Casa com 3 quartos no Bairro X em Campo Grande."
 */
export function generatePropertyImageAlt(property, options = {}) {
  const {
    index = 0,
    total = 1,
    context = 'foto',
  } = options;

  if (!property) return 'Imóvel';

  const typeLabel = getPropertyTypeLabel(property.type) || property.type || 'Imóvel';
  const rooms = countRooms(property);
  const neighborhood = property.neighborhood || '';
  const city = property.city || '';
  const purpose = formatPurpose(property.purpose);
  const title = property.title || '';

  const parts = [];

  if (index === 0 && property.coverImage) {
    parts.push(`${typeLabel}${rooms ? ` com ${rooms}` : ''}`);
  } else {
    parts.push(`${typeLabel}${rooms ? ` com ${rooms}` : ''} — ${context} ${index + 1}`);
  }

  if (neighborhood && city) {
    parts.push(`no ${neighborhood} em ${city}`);
  } else if (city) {
    parts.push(`em ${city}`);
  } else if (neighborhood) {
    parts.push(`no ${neighborhood}`);
  }

  if (purpose) parts.push(purpose);

  let alt = parts.join(' ').replace(/\s+/g, ' ').trim();

  if (!alt.endsWith('.') && !alt.endsWith('!')) alt += '.';

  if (total > 1 && index > 0) {
    alt = alt.replace(/\.$/, ` (${index + 1} de ${total}).`);
  }

  if (title && alt.length < 40) {
    alt = `${title}. ${alt}`;
  }

  return alt.substring(0, 250);
}

export function generateGalleryAlts(property) {
  const images = [];
  if (property?.coverImage) images.push(property.coverImage);
  if (Array.isArray(property?.images)) {
    property.images.forEach((img) => {
      if (img && !images.includes(img)) images.push(img);
    });
  }

  return images.map((_, index) =>
    generatePropertyImageAlt(property, {
      index,
      total: images.length,
      context: index === 0 ? 'foto principal' : 'foto',
    })
  );
}
